import { LabelValues } from 'Modules'

export const enum UserRewardLevelEnum {
  F1 = 0,
  F2 = 1,
  F3 = 2,
}

export const LEVEL_LABEL: LabelValues[] = [
  { label: 'Level F1', value: UserRewardLevelEnum.F1 },
  { label: 'Level F2', value: UserRewardLevelEnum.F2 },
  { label: 'Level F3', value: UserRewardLevelEnum.F3 },
]
